<template>
  <div>
    <ul>
      <li v-for="(item) in listItems" :key="item.order">
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    listItems: {
      type: Array,
      required: true,
    }
  },
}
</script>
